/*eslint-disable*/
import React, { useState, useEffect } from "react";
import Axios from 'axios';
import ApiConfig from "_config/ApiConfig";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import FormControl from "@material-ui/core/FormControl";
//import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import DefaultInput from "components/ToggleVisibility/DefaultInput.js";

import ToggleVisibilityAddInput from "components/ToggleVisibility/ToggleVisibilityAddInput.js";

import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle.js";

const useStyles = makeStyles(profilePageStyle);

export default function SectionFournisseurPage() {

  const getFournisseurProduct = async (ids) => {
    try {
      Axios.defaults.withCredentials = true;
      Axios.get(`${ApiConfig.baseUrl}/Controls/GetFournisseurProduct.php`)
        .then(res => {
          //console.log(res.data.fournisseurproductdata)
          setFournisseurProduct(res.data.fournisseurproductdata);
          return;
        })
    } catch (error) { throw error; }
  };

  const [isFournisseurProduct, setFournisseurProduct] = useState([]);
  const [fournisseurSelect, setFournisseurSelect] = useState([]);

  sessionStorage.setItem("getFournisseurSelect", fournisseurSelect);

  const classes = useStyles();
  useEffect(() => {
    getFournisseurProduct();
  }, []);

  return (
      <div className={classNames(classes.main, classes.mainRaised_)}>
        <div className={classes.container_}>
          <label>FOURNISSEUR </label><ToggleVisibilityAddInput>
          <DefaultInput 
           valueString={'Fournisseur'}
           />
           </ToggleVisibilityAddInput>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <Select
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              value={fournisseurSelect}
              onChange={event => setFournisseurSelect(event.target.value)}
              inputProps={{
                name: "fournisseurSelect",
                id: "fournisseurSelect"
              }}
            >
              {isFournisseurProduct.map((item) => (
                <MenuItem key={item.id_frn}
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected
                  }}
                  value={item.id_frn}
                >
                  {item.design_frn}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
  );
}
